import React from 'react'
// components
import IncidentReport from './incident'
// constants
import {
  fieldMap as incidentFieldMap,
  resolveAsync as incidentResolveAsync
} from '../reports/incident/fields/staging/fieldMap'
import { fieldMap as incidentFieldMapProd } from '../reports/incident/fields/production/fieldMap'
// types
import { ApolloClient } from '@apollo/client'

export type FieldTransform = (value: any) => Record<string, unknown>

export interface ReportComponentProps {
  initialValues?: Record<string, unknown>
}

export interface ReportConfig {
  templateId: string
  filename: string
  component: React.ComponentType<ReportComponentProps>
  fieldMap: Partial<Record<string, string | FieldTransform>>
  resolveAsync?: (values: Record<string, unknown>, apolloClient: ApolloClient) => Promise<Record<string, unknown>>
}

const reports: ReportConfig[] = [
  {
    templateId: '3235c824-bd3c-4029-ae36-517ba052f088',
    filename: 'incident-report.pdf',
    component: IncidentReport,
    fieldMap: incidentFieldMap,
    resolveAsync: incidentResolveAsync
  },
  {
    templateId: 'b14aa5fc-619a-4574-b1dd-db8362666244',
    filename: 'incident-report.pdf',
    component: IncidentReport,
    fieldMap: incidentFieldMapProd,
    resolveAsync: incidentResolveAsync
  }
]

export const REPORT_REGISTRY: Record<string, ReportConfig> = Object.fromEntries(reports.map((r) => [r.templateId, r]))
